import type { ViewRData } from "../types/unity";

export type SpaceDeletionSaveRecoveryPhase = "saving" | "recovering";

export interface SpaceDeletionSaveRecoveryContext {
  active: boolean;
  phase: SpaceDeletionSaveRecoveryPhase;
  spaceId: string | null;
  spaceIndex: number | null;
  viewrGCSPath: string;
  startedAt: number;
  hasRetried: boolean;
}

export interface LatestViewRDataDetail {
  viewRData: ViewRData;
  spacesCount: number;
  currentSpaceIndex: number;
}

const DEFAULT_CONTEXT: SpaceDeletionSaveRecoveryContext = {
  active: false,
  phase: "saving",
  spaceId: null,
  spaceIndex: null,
  viewrGCSPath: "",
  startedAt: 0,
  hasRetried: false,
};

let recoveryContext: SpaceDeletionSaveRecoveryContext = DEFAULT_CONTEXT;
let latestViewRDataDetail: LatestViewRDataDetail | null = null;

export function setSpaceDeletionSaveRecoveryContext(
  next: Omit<SpaceDeletionSaveRecoveryContext, "active" | "startedAt"> & {
    startedAt?: number;
  },
): void {
  recoveryContext = {
    active: true,
    phase: next.phase,
    spaceId: next.spaceId,
    spaceIndex: next.spaceIndex,
    viewrGCSPath: next.viewrGCSPath,
    startedAt: next.startedAt ?? Date.now(),
    hasRetried: next.hasRetried,
  };
}

export function markSpaceDeletionRecoveryRetrying(): void {
  if (!recoveryContext.active) return;
  recoveryContext = {
    ...recoveryContext,
    phase: "recovering",
    hasRetried: true,
  };
}

export function clearSpaceDeletionSaveRecoveryContext(): void {
  recoveryContext = DEFAULT_CONTEXT;
}

export function getSpaceDeletionSaveRecoveryContext(): SpaceDeletionSaveRecoveryContext {
  return recoveryContext;
}

export function setLatestViewRDataDetail(detail: LatestViewRDataDetail): void {
  latestViewRDataDetail = detail;
}

export function clearLatestViewRDataDetail(): void {
  latestViewRDataDetail = null;
}

export function getLatestViewRDataDetail(): LatestViewRDataDetail | null {
  return latestViewRDataDetail;
}
